import { Route, useRouteMatch, useParams, useHistory } from "react-router-dom";
import { imgUrl, albums as al } from "./modules/Arrays";
import Track from "./Track";

function Album() {
    const history = useHistory();
    const { alb } = useParams();
    const { path } = useRouteMatch();
    const cleanParam = alb.replace(/-/g, " ").toLowerCase();
    const albums = al.filter(album => album.album.replace(/-/g," ").toLowerCase().match(cleanParam));

    if(!albums) return(
        <h2>Not Found</h2>
    );
    const albumContent = albums.map(song => (
        <Track 
            song={song} 
            key={song.id} 
            link={`/download/${song.id}-${song.title.replace(/ /g,'-')}`} 
            img={imgUrl+"dl.png"} 
            alt={`Download ${ song.title }`} />
    ))
    

    return (
        <>
            <Route exact path={path}>
                <button onClick={history.goBack}>Back</button>
                <h4>Songs in {albums[0].album} by {albums[0].artist}</h4>
                <div className="grid-4">
                    {albumContent}
                </div>
            </Route>
            <Route path={path+"/:"}>
                <h2>404. Page Not Found</h2>
            </Route>
        </>
    );
}

export default Album;